import {createAction, createReducer} from 'redux-act';
import {fetchQuoteItemV2} from 'actions/cart/cart';
import {FULFILLED} from 'redux-promise-middleware';
import {AxiosResponse} from 'axios';
import {QuoteItemType} from 'constants/flow/flowTypesCart';

export const initialState = {
    subscriptionMode: false,
    currentSubscriptionPlan: '',
};

export type SubscriptionType = {
    subscriptionMode: boolean;
    currentSubscriptionPlan: string;
};

export const setSubscriptionMode = createAction<boolean>('CONTACTS_SET_SUBSCRIPTION_MODE');

export const setSubscriptionPlan = createAction<string>('CONTACTS_SET_SUBSCRIPTION_PLAN');

export const resetSubscription = createAction('CONTACTS_RESET_SUBSCRIPTION');

export const subscription = createReducer<SubscriptionType>({}, initialState)
    .on(`${setSubscriptionMode}`, (state, payload: boolean) => ({
        ...state,
        subscriptionMode: payload,
    }))
    .on(`${setSubscriptionPlan}`, (state, payload: string) => ({
        ...state,
        currentSubscriptionPlan: payload,
    }))
    .on(`${fetchQuoteItemV2}_${FULFILLED}`, (state, payload: AxiosResponse<QuoteItemType>) => {
        if (!('subscription' in payload.data)) {
            return state;
        }
        return {
            ...state,
            subscriptionMode: payload.data.subscription.subscriptionMode,
            currentSubscriptionPlan: payload.data.subscription.currentSubscriptionPlan,
        };
    })
    .on(resetSubscription, () => initialState);
